import { defineMessages } from '@/i18n'

/** Тексты холста дизайн-блока: быстрый тулбар, пустые состояния, ручки элементов. */
export const messages = defineMessages({
  ru: {
    dropImage: 'Нажмите или перетащите картинку',
    close: 'Закрыть',
    addElement: 'Добавить элемент',
    noContent: 'Нет контента',
    emptyTitle: 'Пустой составной блок',
    emptyHint: 'Соберите блок из элементов — нажмите «+» внизу или выберите в панели справа',
    textSize: 'Размер текста',
    backdrop: 'Подложка',
    tilt: 'Наклон',
    styleOf: (label: string) => `Стиль: ${label}`,
    addBadge: 'Добавить бейдж',
    badge: 'Бейдж',
    rows: 'Строки',
    rowsShort: (n: number) => `${n} стр`,
    columns: 'Столбцы',
    columnsShort: (n: number) => `${n} стл`,
    badgeIcon: 'Иконка бейджа',
    badgeText: 'Текст бейджа',
    removeBadge: 'Удалить бейдж',
    heading: 'Заголовок',
    paragraph: 'Текст абзаца',
    cell: 'Ячейка',
    replaceImage: 'Заменить картинку',
    replace: 'Заменить',
    removeImage: 'Удалить картинку',
    remove: 'Удалить',
    dragElement: 'Перетащить элемент',
    removeElement: 'Удалить элемент',
    unsupported: (type: string) => `Элемент «${type}» студия не отображает`,
    less: (label: string) => `${label}: меньше`,
    more: (label: string) => `${label}: больше`,
  },
  en: {
    dropImage: 'Click or drag an image here',
    close: 'Close',
    addElement: 'Add element',
    noContent: 'No content',
    emptyTitle: 'Empty composite block',
    emptyHint: 'Build the block from elements — click “+” below or pick one in the right panel',
    textSize: 'Text size',
    backdrop: 'Backdrop',
    tilt: 'Tilt',
    styleOf: (label: string) => `Style: ${label}`,
    addBadge: 'Add badge',
    badge: 'Badge',
    rows: 'Rows',
    rowsShort: (n: number) => `${n} ${n === 1 ? 'row' : 'rows'}`,
    columns: 'Columns',
    columnsShort: (n: number) => `${n} ${n === 1 ? 'col' : 'cols'}`,
    badgeIcon: 'Badge icon',
    badgeText: 'Badge text',
    removeBadge: 'Remove badge',
    heading: 'Heading',
    paragraph: 'Paragraph text',
    cell: 'Cell',
    replaceImage: 'Replace image',
    replace: 'Replace',
    removeImage: 'Remove image',
    remove: 'Remove',
    dragElement: 'Drag element',
    removeElement: 'Delete element',
    unsupported: (type: string) => `The studio can’t display the “${type}” element`,
    less: (label: string) => `${label}: decrease`,
    more: (label: string) => `${label}: increase`,
  },
})
